module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-Doma-Home.7cb0aabf.gif";